import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from '../Council/MemberInfo.module.scss';
import calendarIcon from '../../../assets/Imagess/calendar-black.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const AlumniInfo = ({ data, handleOnClose, setShowDeletePopup, type }) => {
  const navigate = useNavigate();

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px' }}
      closeStyle={{ top: '25px', right: '25px' }}
      closeWhite={false}
    >
      <div>
        <img
          src={sanitizeAndValidateUrl(
            'ambassador' === type
              ? `${data?.url}${data?.ambassadorImage}`
              : `${data?.url}${data?.alumniImage}`
          )}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['modal-image']}
        />
      </div>
      <div className={styles['info-container']}>
        <div className={styles['row']}>
          {'ambassador' === type ? (
            <div>
              <p className={styles['key']}>الاسم</p>
              <p className={styles['value']}>{data?.ambassadorName_AR}</p>
              <p className={styles['key']}>Country</p>
              <p className={styles['value']}>
                {data?.flag && data?.flag[0]?.countryName_EN}
              </p>
            </div>
          ) : (
            <div>
              <p className={styles['key']}>الاسم</p>
              <p className={styles['value']}>{data?.alumniName_AR}</p>
              <p className={styles['key']}>إنجازات الخريجين</p>
              <p
                className={styles['value']}
                style={{ overflowY: 'scroll', maxHeight: '25vh' }}
                dangerouslySetInnerHTML={{
                  __html: he.decode(data.achievements_AR),
                }}
              />
            </div>
          )}
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              'ambassador' === type
                ? navigate(`/home/edit-ambassador/${data?.alumniAmbassadorId}`)
                : navigate(
                    `/home/edit-success-story/${data?.alumniSuccessStoryId}`
                  );
            }}
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AlumniInfo;
